import PageDataLoader from '../../lib/page-data/loader';
import PageKey from '../../lib/page-data/key';

import {
  CALENDAR_REQUEST,
  CALENDAR_RECEIVE,
  CALENDAR_FAILURE,
  TRAINING_SESSION_REQUEST,
  TRAINING_SESSION_RECEIVE,
  TRAINING_SESSION_FAILURE,
  TRAINING_AVAILABILITY_REQUEST,
  TRAINING_AVAILABILITY_RECEIVE,
  TRAINING_AVAILABILITY_FAILURE,
  PAGE_DATA_LOAD,
} from '../action-types';
import ApiRequestException from '../../exceptions/api-request-exception';

export const fetchClubCalendar =
  ({ clubId, year, month, request, showCompleteWeeks }) =>
  async (dispatch) => {
    try {
      const pageKey = new PageKey(clubId, 'calendar', { year, month, showCompleteWeeks });
      dispatch({ type: CALENDAR_REQUEST, payload: { clubId, year, month } });
      const pageData = await PageDataLoader.getPageData(pageKey, request);
      dispatch({
        type: CALENDAR_RECEIVE,
        payload: { clubId, year, month, calendar: pageData.data },
      });
      dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
      return {};
    } catch (error) {
      let statusCode = 500;
      if (error) {
        statusCode = error.errorStatusCode || statusCode;
      }
      dispatch({
        type: CALENDAR_FAILURE,
        payload: { clubId, year, month, statusCode, error },
      });
      return { error };
    }
  };

export const fetchTrainingSession = (clubId, sessionId, request) => async (dispatch) => {
  try {
    const pageKey = new PageKey(clubId, 'training', { id: sessionId });
    dispatch({ type: TRAINING_SESSION_REQUEST, payload: { clubId, sessionId } });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({
      type: TRAINING_SESSION_RECEIVE,
      payload: { clubId, sessionId, session: pageData.data },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }
    dispatch({
      type: TRAINING_SESSION_FAILURE,
      payload: { clubId, sessionId, statusCode, error },
    });
    return { error };
  }
};

export const fetchTrainingAvailability = (sessionId) => async (dispatch) => {
  try {
    dispatch({
      type: TRAINING_AVAILABILITY_REQUEST,
      payload: { sessionId },
    });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `/v2/training/sessions/${sessionId}/availability`,
    );
    if (response.status !== 200) {
      dispatch({
        type: TRAINING_AVAILABILITY_FAILURE,
        payload: {
          sessionId,
          error: ApiRequestException('Error retrieving availability', response.status),
        },
      });
    }

    const data = await response.json();
    dispatch({
      type: TRAINING_AVAILABILITY_RECEIVE,
      payload: { sessionId, data },
    });
  } catch (error) {
    dispatch({
      type: TRAINING_AVAILABILITY_FAILURE,
      payload: { sessionId, error },
    });
  }
};
